import { useSyncExternalStore } from 'react';

interface WindowSizeState {
    width: number;
    height: number;
    offsetTop: number;
}

const defaultWindowSize: WindowSizeState = { width: 0, height: 0, offsetTop: 0 };

let cachedWindowSize: WindowSizeState = defaultWindowSize;

function getWindowSizeSnapshot(): WindowSizeState {
    if (typeof window === 'undefined') return cachedWindowSize;

    const vp = window.visualViewport;
    if (!vp) return cachedWindowSize;

    const { width = 0, height = 0, offsetTop = 0 } = vp;

    if (width === cachedWindowSize.width && height === cachedWindowSize.height && offsetTop === cachedWindowSize.offsetTop) {
        return cachedWindowSize;
    }

    cachedWindowSize = { width, height, offsetTop };
    return cachedWindowSize;
}

function subscribeToWindowSize(onStoreChange: () => void): () => void {
    const visualViewport = window.visualViewport;
    if (!visualViewport) return () => {};

    visualViewport.addEventListener('resize', onStoreChange);
    visualViewport.addEventListener('scroll', onStoreChange);

    return () => {
        visualViewport.removeEventListener('resize', onStoreChange);
        visualViewport.removeEventListener('scroll', onStoreChange);
    };
}

/**
 * Custom hook to track window size and viewport information
 * @returns Current window dimensions and offsetTop
 */
export function useWindowSize(): WindowSizeState {
    return useSyncExternalStore(subscribeToWindowSize, getWindowSizeSnapshot);
}
